<script>
  let klass = '';
  export { klass as class };
</script>

<tr class="s-tbl-row {klass}">
  <slot />
</tr>
